module.exports = __webpack_public_path__ + "img/artillery-wagon-base-shadow-2.3c4e55cb.png";